import React, { useState } from "react";
import { Input, Textarea } from "../../../ui/inputs/Input";
import useTable from "../../../components/useTable";
import { DangerButton, InfoButton, PrimaryButton, WarningButton } from "../../../ui/buttons/Button";

const headCells = [
  {
    id: "numeroDocumento",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "Nº Documento",
    textAlign: "center",
  },
  {
    id: "concepto",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "Concepto",
    textAlign: "center",
  },
];

export default function AprobarSolicitud({ setTabla}) {

  const [records, setRecords] = useState([]);
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const { 
    TblContainer,
    TblHead,
    recordsAfterPagingAndSorting,
    TblPagination
  } = useTable(records, headCells, filterFn);
  
  return <div className="col-8 m-0 p-2 border rounded">
    <header className="col-12 m-0 px-4 py-2 d-flex justify-content-between azulGradiant rounded-top text-light">
      <h3 className="m-0 fw-bold">Enviar Solicitud de Pago</h3>
      <a type = 'button' onClick={() => setTabla(0)} className="fw-bold text-light fs-6">
        Salir <i className="fa fa-times ms-2"></i>
      </a>
    </header>
    <div className="col-12 m-0 my-2 p-0 d-flex justify-content-between">
      <div className="col-auto m-0 p-0">
        <Input label = 'Código:' />
      </div>
      <div className="col-auto m-0 p-0">
        <Input labeel = 'Fecha:' type = 'date'/>
      </div>
    </div>
    <div className="col-12 m-0 mb-2 p-0">
      <Textarea label = 'Observaciones:' style = {{height: 70}}/>
    </div>
    <div className="col-12 m-0 p-0 d-flex">
      <div className="col-11 m-0 p-0">
        <TblContainer>
        <TblHead />
        <tbody>
          {records &&
            recordsAfterPagingAndSorting().map((item, index) => (
              <tr key={index}></tr>
            ))}
        </tbody>
      </TblContainer>
      </div>
      <div className="col-1 m-0 p-0 d-flex flex-column align-items-center justify-content-center gap-2">
        <div className="col-auto m-0 p-0">
          <PrimaryButton icon = 'fa-plus m-0'/>
        </div>
        <div className="col-auto m-0 p-0">
          <InfoButton icon = 'fa-eye m-0'/>
        </div>
        <div className="col-auto m-0 p-0">
          <WarningButton icon = 'fa-edit m-0'/>
        </div>
        <div className="col-auto m-0 p-0">
          <DangerButton icon = 'fa-trash-alt m-0'/>
        </div>
      </div>
    </div>
  </div>
}